module.exports = __webpack_public_path__ + "static/media/CircularStd-Book.6365c40a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CircularStd-Book.otf
// module id = 727
// module chunks = 0